

// import IlegTermsAndConditions from './IlegTermsAndConditions';
import CmgTermsAndConditions from './CmgTermsAndConditions';
import CblsTermsAndConditions from './CblsTermsAndConditions';
import ISPlatformTermsAndConditions from './ISPlatformTermsAndConditions';
import ISCustomerTermsAndConditions from './ISCustomerTermsAndConditions';
import CosmTermsAndConditions from './CosmTermsAndConditions';
import PromoTermsAndConditions from './PromoTermsAndConditions';
import HealthCreditTermsAndConditions from './HealthCreditTermsAndConditions';
import LoyaltyProgramTermsAndConditions from './LoyaltyProgramTermsAndConditions';

const TermsAndConditions = ({type, ...props}) => {
  let t = <ISPlatformTermsAndConditions />;

  switch (type) {
    case 'cmg':
      t = <CmgTermsAndConditions />
      break;
    case 'cbls':
      t = <CblsTermsAndConditions />
      break;
    // case 'ileg':
    //   t = <IlegTermsAndConditions />
    //   break;
    case 'customer':
      t = <ISCustomerTermsAndConditions {...props} />
      break;
    case 'platform':
      t = <ISPlatformTermsAndConditions {...props} />
      break;
    case 'cosm':
      t = <CosmTermsAndConditions />
      break;
    case 'promo':
      t = <PromoTermsAndConditions {...props} />
      break;
    case 'healthcredit':
      t = <HealthCreditTermsAndConditions />
      break;
    case 'loyalty-program':
      t = <LoyaltyProgramTermsAndConditions />
      break;
  }
  return t;
};

export default TermsAndConditions
